import { CustomerType } from 'services/orders/types';
import { Commodity } from 'services/delivery/types';

export const CONSUMPTION_OF_ELECTRICITY_KWH = 500000;
export const CONSUMPTION_OF_GAS_TERMS = 30000;

export const exceedsTheLimit = (
  customerType: CustomerType,
  commodity: Commodity,
  annualUsage: number
): boolean => {
  if (customerType === CustomerType.RESIDENTIAL) {
    return false;
  }
  return (
    (commodity === Commodity.ELECTRICITY && annualUsage > CONSUMPTION_OF_ELECTRICITY_KWH) ||
    (commodity === Commodity.GAS && annualUsage > CONSUMPTION_OF_GAS_TERMS)
  );
};

export const statePositions = {
  Alaska: { lat: 61.385, lng: -152.2683 },
  Alabama: { lat: 32.799, lng: -86.8073 },
  Arkansas: { lat: 34.9513, lng: -92.3809 },
  Arizona: { lat: 33.7712, lng: -111.3877 },
  California: { lat: 36.17, lng: -119.7462 },
  Colorado: { lat: 39.0646, lng: -105.3272 },
  Connecticut: { lat: 41.5834, lng: -72.7622 },
  Delaware: { lat: 38.7, lng: -75.5148 },
  Florida: { lat: 27.8333, lng: -81.717 },
  Georgia: { lat: 32.9866, lng: -83.6487 },
  Hawaii: { lat: 21.1098, lng: -157.5311 },
  Iowa: { lat: 42.0046, lng: -93.214 },
  Idaho: { lat: 44.2394, lng: -114.5103 },
  Illinois: { lat: 40.0, lng: -89.5022 },
  Indiana: { lat: 39.8647, lng: -86.2604 },
  Kansas: { lat: 38.5111, lng: -96.8005 },
  Kentucky: { lat: 37.669, lng: -84.6514 },
  Louisiana: { lat: 31.1801, lng: -91.8749 },
  Massachusetts: { lat: 42.2373, lng: -72.0 },
  Maryland: { lat: 39.3724, lng: -77.0 },
  Maine: { lat: 44.6074, lng: -69.3977 },
  Michigan: { lat: 43.3504, lng: -84.5603 },
  Minnesota: { lat: 45.7326, lng: -93.9196 },
  Missouri: { lat: 38.4623, lng: -92.302 },
  Mississippi: { lat: 32.7673, lng: -89.6812 },
  Montana: { lat: 46.9048, lng: -110.3261 },
  'North Carolina': { lat: 35.6411, lng: -79.8431 },
  'North Dakota': { lat: 47.5362, lng: -99.793 },
  Nebraska: { lat: 41.1289, lng: -98.2883 },
  'New Hampshire': { lat: 43.4108, lng: -71.5653 },
  'New Jersey': { lat: 39.533851, lng: -74.871826 },
  'New Mexico': { lat: 34.8375, lng: -106.2371 },
  Nevada: { lat: 38.4199, lng: -117.1219 },
  'New York': { lat: 42.7497, lng: -75.9384 },
  Ohio: { lat: 40.2736, lng: -82.7755 },
  Oklahoma: { lat: 35.5376, lng: -96.9247 },
  Oregon: { lat: 44.5672, lng: -122.1269 },
  Pennsylvania: { lat: 40.5773, lng: -77.264 },
  'Rhode Island': { lat: 41.6772, lng: -71.5101 },
  'South Carolina': { lat: 33.8191, lng: -80.9066 },
  'South Dakota': { lat: 44.2853, lng: -99.4632 },
  Tennessee: { lat: 35.7449, lng: -86.7489 },
  Texas: { lat: 31.106, lng: -97.6475 },
  Utah: { lat: 40.1135, lng: -111.8535 },
  Virginia: { lat: 37.768, lng: -78.2057 },
  Vermont: { lat: 44.0407, lng: -72.7093 },
  Washington: { lat: 47.3917, lng: -121.5708 },
  'Washington D.C.': { lat: 38.8992, lng: -77.0506 },
  Wisconsin: { lat: 44.2563, lng: -89.6385 },
  'West Virginia': { lat: 38.468, lng: -80.9696 },
  Wyoming: { lat: 42.7475, lng: -107.2085 },
};

export const defaultMapStyle = [
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#333333',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dedede',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f2f2f2',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e9e9e9',
      },
      {
        lightness: 17,
      },
    ],
  },
];
